var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrdIconFigma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09064 0.818359H0.636097C0.539655 0.818359 0.447163 0.856671 0.378968 0.924866C0.310773 0.993061 0.272461 1.08555 0.272461 1.182V12.8184C0.272461 12.9148 0.310773 13.0073 0.378968 13.0755C0.447163 13.1437 0.539655 13.182 0.636097 13.182H9.72701C9.82345 13.182 9.91594 13.1437 9.98414 13.0755C10.0523 13.0073 10.0906 12.9148 10.0906 12.8184V4.81836H6.45428C6.35784 4.81836 6.26534 4.78005 6.19715 4.71185C6.12895 4.64366 6.09064 4.55117 6.09064 4.45472V0.818359Z",
    fill: "#147AF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54508 0.818359H6.57635C6.62472 0.81838 6.67149 0.837956 6.70726 0.873541L10.0173 4.18354C10.0351 4.20142 10.0491 4.22244 10.0587 4.24548C10.0683 4.26852 10.0733 4.29316 10.0733 4.31808V4.34935H6.54508V0.818359Z",
    fill: "#147AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrdIconFigma);
export default __webpack_public_path__ + "static/media/prd-icon-figma.ac0ce59cbc8ab040f67c66210e51a41e.svg";
export { ForwardRef as ReactComponent };